/**
 * GA4 Click Events - Fires events on specific UI interactions
 * clickLeftOnNotificationBar, clickRightOnNotificationBar, ClickTrovelleIcon
 */

(function () {
  const gtag = window.trovelle?.ga4?.gtag;
  const measurementId = window.trovelle?.ga4?.measurementId;
  if (!gtag || !measurementId) return;

  function getPageParams() {
    const route = window.trovelle?.ga4?.route?.getRoute?.();
    return {
      page_location: window.location.href,
      page_title: document.title || '',
      referrer: document.referrer || '',
      page_type: route?.pageType || 'page',
    };
  }

  function fireClickEvent(eventName) {
    gtag('event', eventName, getPageParams());
  }

  document.addEventListener(
    'click',
    (e) => {
      const target = e.target?.closest?.('button, a');
      if (!target) return;

      if (target.closest('.announcement-bar')) {
        if (target.classList?.contains('slideshow-control--previous')) {
          fireClickEvent('clickLeftOnNotificationBar');
        } else if (target.classList?.contains('slideshow-control--next')) {
          fireClickEvent('clickRightOnNotificationBar');
        }
        return;
      }

      if (target.classList?.contains('header-logo') || target.closest('.header-logo')) {
        fireClickEvent('ClickTrovelleIcon');
      }
    },
    { capture: true }
  );
})();
